<template>
  <article id="admin" class="container py-5">
    <section class="title">
      <h1 class="pt-5">관리자 페이지</h1>
    </section>
    <div class="btn-group my-5">
      <button
        class="btn btn-primary"
        @click="sectionIndex = i"
        v-for="(btn, i) in sectionList"
        :key="i"
      >
        {{ btn }}
      </button>
    </div>

    <section class="webzine" v-if="sectionIndex === 0">
      <div class="upload-webzine">
        <div class="info" v-if="editWebzineId == undefined">
          <h2 class="py-3">웹진 업로드</h2>
          <p>새 웹진을 업로드합니다.</p>
        </div>
        <div class="info" v-if="editWebzineId !== undefined">
          <h2 class="py-3">웹진 수정</h2>
          <p>웹진을 수정합니다.</p>
        </div>
        <b-row>
          <b-col cols="5" class="thumbnail">
            <h5 class="my-3">썸네일</h5>
            <label
              class="new-webzine-thumbnail d-block shadow-sm overflow-hidden bg-grey-lightest p-4"
              :class="newWebzine.thumbnail.length > 0 ? 'bg-grey-light' : ''"
              :style="`backgroundImage:url(${newWebzine.thumbnail})`"
            >
              <i
                class="icon icon-loading icon-40"
                ref="loading"
                v-if="newWebzine.thumbnail.length == 0"
              ></i>
              <span v-if="newWebzine.thumbnail.length == 0" ref="loadingMsg">
                여길 눌러 썸네일을 올려주세요.
              </span>
              <input type="file" @change="uploadThumbnail" class="d-none" />
            </label>
          </b-col>
        </b-row>
        <section class="my-4">
          <h6 class="text-lg-18 mb-2">제목</h6>
          <b-row class="align-items-end">
            <b-col cols="12">
              <input
                type="text"
                class="text-lg-24"
                placeholder="제목을 입력하세요"
                v-model="newWebzine.title"
              />
            </b-col>
            <b-col cols="6">
              <label for="datepicker" class="pt-3 text-lg-16">날짜</label>
              <b-form-datepicker
                id="datepicker"
                :today-button="true"
                label-today-button="오늘로 설정하기"
                v-model="newWebzine.createdAt"
                class="mt-2"
              >
              </b-form-datepicker>
            </b-col>
          </b-row>
        </section>
        <section class="my-4">
          <h5 class="my-3">에디터</h5>
          <vue-editor
            class="editor w-100 border-0"
            placeholder="블로그에 글을 올리듯이 글을 써주세요."
            v-model="newWebzine.desc"
            useCustomImageHandler
            @image-added="handleImageAdded"
          />
        </section>
        <section class="btns my-4 text-right">
          <button
            ref="uploadBtn"
            class="btn btn-primary px-5 py-3"
            @click="uploadWebzine('allWebzine')"
            v-if="editWebzineId == undefined"
          >
            업로드
          </button>
          <button
            class="btn btn-primary px-5 py-3"
            @click="updateWebzine('allWebzine')"
            v-if="editWebzineId !== undefined"
          >
            수정완료
          </button>
        </section>
      </div>
      <div class="edit-webzine">
        <h2 class="py-3">
          올린 웹진들
        </h2>
        <b-table striped hover :items="allWebzine" :fields="fields.webzine">
          <template v-slot:cell(thumbnail)="data">
            <img :src="data.item.thumbnail" class="table_thumbnail" />
          </template>
          <template v-slot:cell(setting)="data">
            <button
              class="d-block btn btn-info"
              @click="editWebzine(data.item)"
            >
              수정하기
            </button>
            <button
              class="d-block btn btn-danger mt-2"
              @click="removeWebzine('allWebzine', data.item)"
            >
              삭제하기
            </button>
          </template>
        </b-table>
      </div>
    </section>

    <section class="dataroom" v-if="sectionIndex === 1">
      <div class="info" v-if="editDataRoomId == undefined">
        <h2 class="py-3">자료 업로드</h2>
        <p>새 자료를 업로드합니다.</p>
      </div>
      <div class="info" v-if="editDataRoomId !== undefined">
        <h2 class="py-3">자료 수정</h2>
        <p>자료를 수정합니다.</p>
      </div>
      <section class="my-5">
        <h5 class="my-3">첨부파일</h5>
        <input type="file" @change="uploadfiles" />
      </section>
      <section class="my-4">
        <h6 class="text-lg-18 mb-2">제목</h6>
        <b-row class="align-items-end">
          <b-col cols="12">
            <input
              type="text"
              class="text-lg-24"
              placeholder="제목을 입력하세요"
              v-model="newDataRoom.title"
            />
          </b-col>
        </b-row>
      </section>
      <section class="my-4">
        <h5 class="my-3">에디터</h5>
        <vue-editor
          class="editor w-100 border-0"
          placeholder="블로그에 글을 올리듯이 글을 써주세요."
          v-model="newDataRoom.desc"
          useCustomImageHandler
          @image-added="handleImageAdded"
        />
      </section>

      <section class="btns my-4 text-right">
        <button
          class="btn btn-primary px-5 py-3"
          @click="uploadDataRoom('allDataRoom')"
          v-if="editDataRoomId == undefined"
        >
          업로드
        </button>
        <button
          class="btn btn-primary px-5 py-3"
          @click="updateDataRoom('allDataRoom')"
          v-if="editDataRoomId !== undefined"
        >
          수정완료
        </button>
      </section>
      <b-table striped hover :items="allDataRoom" :fields="fields.dataRoom">
        <template v-slot:cell(title)="data">
          <p class="table_title">{{ data.item.title }}</p>
        </template>
        <template v-slot:cell(setting)="data">
          <button class="d-block btn btn-info" @click="editDataRoom(data.item)">
            수정하기
          </button>
          <button
            class="d-block btn btn-danger mt-2"
            @click="removeDataRoom('allDataRoom', data.item)"
          >
            삭제하기
          </button>
        </template>
      </b-table>
    </section>

    <section class="movie" v-if="sectionIndex === 2">
      <h2 class="py-3">Movie 업로드</h2>
      <p class="text-lg-16 text-14">
        영상을 유튜브에 업로드한 뒤 '공유' 버튼을 눌러 나오는 링크를 밑에
        입력하세요.
        <img
          :src="require('../assets/img/video-confirm.png')"
          alt="영상을 유튜브에 업로드한 뒤 '공유' 버튼을 눌러 나오는 링크를 밑에 입력하세요."
          class="w-50 d-block my-2"
        />
      </p>
      <input
        type="text"
        placeholder="유튜브 링크를 여기에 입력하세요, 예시 : https://youtu.be/xxxxxxxxxxxxx"
        v-model="movieLink"
        class="mt-2 text-lg-24"
      />
      <div v-show="movieLink !== ''">
        <h3 class="my-3">이 영상이 맞나요?</h3>
        <p class="text-lg-16 text-14">
          영상이 맞다면 업로드를 눌러주세요. 아니라면 다시 입력하여 보세요.
        </p>
        <youtube
          :video-id="movieLink.split('/')[3]"
          class="new-movie-confirm"
        ></youtube>
        <b-button
          variant="primary"
          class="mt-3 px-4 py-2"
          @click="uploadMovie('allMovies')"
          v-if="editMovieId == undefined"
          >업로드</b-button
        >
        <b-button
          variant="primary"
          class="mt-3 px-4 py-2"
          @click="updateMovie('allMovies')"
          v-if="editMovieId !== undefined"
          >수정완료</b-button
        >
      </div>
      <b-table
        striped
        hover
        :items="allMovies"
        :fields="fields.movies"
        class="mt-5"
      >
        <template v-slot:cell(src)="data">
          <youtube
            :video-id="data.item.src.split('/')[3]"
            class="movie-el"
          ></youtube>
        </template>
        <template v-slot:cell(setting)="data">
          <button
            class="d-block btn btn-danger mt-2"
            @click="removeMovie('allMovies', data.item)"
          >
            삭제하기
          </button>
        </template>
      </b-table>
    </section>

    <section class="map" v-if="sectionIndex === 3">
      <div class="upload-map">
        <div class="info" v-if="editMapId == undefined">
          <h2 class="py-3">맵 업로드</h2>
          <p>새 마술소를 업로드합니다.</p>
        </div>
        <div class="info" v-if="editMapId !== undefined">
          <h2 class="py-3">맵 수정</h2>
          <p>마술소를 수정합니다.</p>
        </div>
        <section class="my-5">
          <h5 class="my-3">이미지</h5>
          <label class="btn btn-primary upload-img-btn">
            <span class="text-lg-16">
              여길 눌러 이미지를 올려주세요.
            </span>
            <input type="file" @change="uploadImage" class="d-none" />
          </label>
          <b-row class="m-0 p-0">
            <b-col
              cols="3"
              class="image w-100 m-1 p-0"
              v-for="(item, i) in newMap.imgs"
              :key="i"
            >
              <div class="cover position-relative overflow-hidden">
                <div
                  class="delete-btn position-absolute w-100 h-100 top-0 left-0"
                >
                  <button
                    class="btn btn-secondary m-3"
                    @click="newMap.imgs.pop(this)"
                  >
                    이 이미지 삭제하기
                  </button>
                </div>
                <img :src="item" :alt="'이미지-' + i" />
              </div>
            </b-col>
          </b-row>
        </section>

        <section class="my-5">
          <h6 class="text-lg-18 mb-2">이름</h6>
          <b-row class="align-items-end">
            <b-col cols="12">
              <input
                type="text"
                class="text-lg-24"
                placeholder="마술소 이름을 입력하세요"
                v-model="newMap.name"
              />
            </b-col>
          </b-row>
        </section>
        <section class="my-5">
          <b-row class="align-items-end">
            <b-col cols="12">
              <h6 class="text-lg-18 mb-2">주소</h6>
              <input
                type="text"
                class="text-lg-24"
                placeholder="주소를 입력하세요"
                v-model="newMap.addr"
              />
            </b-col>
          </b-row>
        </section>

        <section class="my-5">
          <b-row class="align-items-end">
            <b-col cols="4">
              <img
                :src="require('../assets/img/pinDesc.png')"
                alt="핀 위치설명 이미지"
              />
            </b-col>
            <b-col cols="8">
              <h6 class="text-lg-18 mb-2">핀 위치 입력</h6>
              <small>
                왼쪽 이미지를 꼭 참고해주세요. 위 사이트의 지도는 구글 맵 API를
                사용하고 있어서 구글 맵에서 핀(마커)를 찍어 사용하고
                있습니다.<br />

                핀을 찍을 곳의 <strong class="text-primary">'위도'</strong>와
                <strong class="text-primary">'경도'</strong>를
                <strong class="text-primary">소수점까지</strong> 모두 입력하셔야
                합니다.
              </small>
              <b-row class="mt-4">
                <b-col cols="6">
                  <input
                    type="number"
                    class="text-lg-20 input-reset"
                    placeholder="위도를 여기 입력하세요. 예시) 37.550281"
                    min="0"
                    v-model="newMap.position.lat"
                  />
                </b-col>
                <b-col cols="6">
                  <input
                    type="number"
                    class="text-lg-20 input-reset"
                    placeholder="경도 여기 입력하세요. 예시) 126.990510"
                    min="0"
                    v-model="newMap.position.lng"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </section>
        <section class="my-4">
          <h6 class="text-lg-18 mb-2">핀 색상</h6>
          <span class="text-14"
            >핀 색상은 지도에 나타나는 핀의 색상을 뜻합니다. 기본은 보라색이며,
            다른색상들을 정할 수 있습니다.</span
          >
          <div class="mt-3">
            <b-form-radio-group v-model="newMap.color" buttons>
              <b-form-radio
                :value="item.value"
                v-for="(item, i) in colors"
                :button-variant="item.text"
                :key="i"
                class="mr-2 rounded-0 p-3 d-flex flex-column align-items-center justify-content-center"
              >
                <template v-if="item.value === newMap.color">
                  <i class="icon icon-checked d-block"></i>
                </template>
                {{ item.text }}
              </b-form-radio>
            </b-form-radio-group>
          </div>
        </section>
        <section class="my-5">
          <b-row class="align-items-end">
            <b-col cols="4">
              <h6 class="text-lg-18 mb-2">전화번호</h6>
              <input
                type="text"
                class="text-lg-24"
                placeholder="전화번호를 입력하세요"
                v-model="newMap.tel"
              />
            </b-col>
            <b-col cols="4">
              <h6 class="text-lg-18 mb-2">공식 웹사이트 주소</h6>
              <input
                type="text"
                class="text-lg-24"
                placeholder="앞에 https://가 꼭 있어야합니다!! 예시)https://www.artmasulso.net"
                v-model="newMap.website"
              />
            </b-col>
            <b-col cols="4">
              <h6 class="text-lg-18 mb-2">공간 운영지기</h6>
              <input
                type="text"
                class="text-lg-24"
                placeholder="예시) 대표: ㅇㅇㅇ / 직원 : ㅇㅇㅇ"
                v-model="newMap.staff"
              />
            </b-col>
          </b-row>
        </section>

        <section class="my-4">
          <h5 class="my-3">마술소 설명</h5>
          <vue-editor
            class="editor w-100 border-0"
            placeholder="블로그에 글을 올리듯이 글을 써주세요. 너무 길면 팝업으로 나올 공간이 부족할 수 있습니다."
            v-model="newMap.desc"
          />
        </section>

        <section class="btns my-4 text-right">
          <button
            ref="uploadBtn"
            class="btn btn-primary px-5 py-3"
            @click="uploadMap('allMap')"
            v-if="editMapId == undefined"
          >
            업로드
          </button>
          <button
            class="btn btn-primary px-5 py-3"
            @click="updateMap('allMap')"
            v-if="editMapId !== undefined"
          >
            수정완료
          </button>
        </section>
        <div class="edit-map">
          <h2 class="py-3">
            올린 마술소들
          </h2>
          <b-table striped hover :items="allMap" :fields="fields.map">
            <template v-slot:cell(imgs)="data">
              <div class="" v-if="data.item.imgs.length < 3">
                <img
                  :src="item"
                  class="table_image mx-1"
                  v-for="(item, i) in data.item.imgs"
                  :key="i"
                />
              </div>
              <div class="" v-if="data.item.imgs.length > 2">
                <img :src="data.item.imgs[0]" class="table_image mx-1" />
                <img :src="data.item.imgs[1]" class="table_image mx-1" />
              </div>
            </template>
            <template v-slot:cell(color)="data">
              <div
                :style="{
                  backgroundColor: `${
                    data.item.color ? data.item.color : `#7a2a90`
                  }`,
                  width: '40px',
                  height: '40px',
                  content: '',
                }"
              ></div>
            </template>
            <template v-slot:cell(setting)="data">
              <button class="d-block btn btn-info" @click="editMap(data.item)">
                수정하기
              </button>
              <button
                class="d-block btn btn-danger mt-2"
                @click="removeMap('allMap', data.item)"
              >
                삭제하기
              </button>
            </template>
          </b-table>
        </div>
      </div>
    </section>

    <section class="intro" v-if="sectionIndex === 4">
      <div class="info">
        <h2 class="py-3">메인페이지 이미지리스트</h2>
        <p>메인페이지의 가장 윗 화면의 이미지 슬라이드를 수정합니다.</p>
      </div>
      <b-row class="d-flex align-items-start">
        <b-col cols="3" class="mb-3" v-for="(item, i) in introImages" :key="i">
          <div
            class="bg-light position-relative"
            :style="{
              width: '240px',
              paddingBottom: '160px',
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              backgroundImage: `url(${item.src})`,
            }"
          >
            <b-btn
              class="position-absolute"
              @click="removeIntroImage(item)"
              :style="{ top: '1rem', right: '1rem' }"
            >
              삭제
            </b-btn>
          </div>
        </b-col>
        <b-col>
          <div
            class="bg-light position-relative"
            :style="{
              width: '240px',
              paddingBottom: '160px',
            }"
          >
            <label class="btn btn-primary position-absolute-center">
              이미지 추가
              <input type="file" @change="uploadIntroImage" class="d-none" />
            </label>
          </div>
        </b-col>
      </b-row>

      <div class="info">
        <h2 class="py-3">갤러리</h2>
        <p>갤러리 페이지의 갤러리에 이미지를 추가합니다.</p>
        <b-row class="d-flex align-items-start">
          <b-col
            cols="3"
            class="mb-3"
            v-for="(item, i) in galleryImages"
            :key="i"
          >
            <div
              class="bg-light position-relative"
              :style="{
                width: '240px',
                paddingBottom: '160px',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundImage: `url(${item.src})`,
              }"
            >
              <b-btn
                class="position-absolute"
                @click="removeGalleryImage(item)"
                :style="{ top: '1rem', right: '1rem' }"
              >
                삭제
              </b-btn>
            </div>
          </b-col>
          <b-col>
            <div
              class="bg-light position-relative"
              :style="{
                width: '240px',
                paddingBottom: '160px',
              }"
            >
              <label class="btn btn-primary position-absolute-center">
                이미지 추가
                <input
                  type="file"
                  @change="uploadGalleryImage"
                  class="d-none"
                />
              </label>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
  </article>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소 | 관리자페이지",
    };
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      sectionList: ["웹진", "자료실", "Movie", "지도", "갤러리"],
      sectionIndex: 0,

      // DB
      allWebzine: [],
      allMovies: [],
      allDataRoom: [],
      allMap: [],

      // 새 웹진 업로드
      newWebzine: {
        thumbnail: "",
        title: "",
        desc: "",
        createdAt: undefined,
      },

      // 웹진 수정 id
      editWebzineId: undefined,

      // 새 자료 업로드
      newDataRoom: {
        title: "",
        desc: "",
        files: "",
        createdAt: undefined,
      },
      editDataRoomId: undefined,

      // Movie 업로드
      movieLink: "",
      editMovieId: undefined,

      // 지도 업로드
      editMapId: undefined,
      newMap: {
        name: "",
        position: {
          lat: "",
          lng: "",
        },
        staff: "",
        addr: "",
        tel: "",
        website: "",
        desc: "",
        imgs: [],
        color: "#7a2a90",
      },
      colors: [
        {
          text: "purple",
          value: "#7a2a90",
        },
        {
          text: "yellow",
          value: "#ffda00",
        },
        {
          text: "orange",
          value: "#f99d1b",
        },
        {
          text: "red",
          value: "#ed1b23",
        },
        {
          text: "dark",
          value: "#222",
        },
      ],

      // 갤러리 업로드
      introImages: [],
      galleryImages: [],

      // 관리 필드
      fields: {
        webzine: ["thumbnail", "title", "createdAt", "setting"],
        dataRoom: ["title", "createdAt", "setting"],
        movies: ["src", "setting"],
        map: ["imgs", "name", "addr", "color", "setting"],
      },
    };
  },
  methods: {
    // DB
    loadAllWebzine() {
      this.$db
        .collection("allWebzine")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allWebzine = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    loadAllDataroom() {
      this.$db
        .collection("allDataRoom")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allDataRoom = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    loadAllMovies() {
      this.$db
        .collection("allMovies")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allMovies = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    loadAllIntroImages() {
      this.$db
        .collection("introImages")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.introImages = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    loadAllGalleryImages() {
      this.$db
        .collection("galleryImages")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.galleryImages = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    loadAllMap() {
      this.$db
        .collection("allMap")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allMap = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    uploadThumbnail(el) {
      const file = el.target.files[0];
      this.$refs.loading.style.opacity = "1";
      this.$refs.loadingMsg.innerHTML = "썸네일을 올리고 있습니다";

      this.$storage
        .ref()
        .child("thumbnail/" + new Date().getTime() + file.name)
        .put(file)
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            this.newWebzine.thumbnail = url;

            this.$bvToast.toast("업로드를 계속 진행해도 괜찮습니다.", {
              title: `썸네일을 성공적으로 업로드했습니다.`,
              toaster: "b-toaster-bottom-center",
              variant: "primary",
              appendToast: true,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 웹진
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      //Vue editor 에서 제공하는 이미지핸들러
      this.$storage
        .ref()
        .child("images/" + new Date().getTime() + file.name) // 위 이미지이름으로 변환하고 그걸 업로드한다
        .put(file)
        .then(function(snapshot) {
          console.log("이미지 업로드 완료");
          snapshot.ref
            .getDownloadURL()
            .then(function(url) {
              console.log(url); //이미지를 업로드 후에 다운로드 가능한 url이 나타나게 한다
              Editor.insertEmbed(cursorLocation, "image", url); //업로드한 이미지를 에디터 안(커서로케이션)에 나타나게 한다
              resetUploader();
            })
            .catch((err) => {
              // 에러코드
              console.log(err);
            });
        });
    },
    uploadWebzine(collection) {
      const self = this;

      this.$db
        .collection(collection)
        .add({
          thumbnail: this.newWebzine.thumbnail,
          title: this.newWebzine.title,
          desc: this.newWebzine.desc,
          createdAt: this.newWebzine.createdAt,
        })
        .then((docRef) => {
          self.loadAllWebzine();
          console.log(docRef.id);

          self.newWebzine.thumbnail = "";
          self.newWebzine.title = "";
          self.newWebzine.desc = "";

          self.$bvToast.toast("업로드 성공!", {
            title: `웹진을 성공적으로 업로드했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
        })
        .catch(function(error) {
          self.$bvToast.toast("업로드에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
          console.log(error);
        });
    },
    editWebzine(el) {
      window.scrollTo(0, 0);
      console.log(this.editWebzineId);

      this.editWebzineId = el._id;
      this.newWebzine.title = el.title;
      this.newWebzine.thumbnail = el.thumbnail;
      this.categorySelected = el.category;
      this.newWebzine.desc = el.desc;
      this.newWebzine.createdAt = el.createdAt;
    },
    updateWebzine(collection) {
      const self = this;

      this.$db
        .collection(collection)
        .doc(this.editWebzineId)
        .update({
          title: this.newWebzine.title,
          thumbnail: this.newWebzine.thumbnail,
          desc: this.newWebzine.desc,
          createdAt: this.newWebzine.createdAt,
        })
        .then(() => {
          alert("수정이 완료됐습니다.");
          self.loadAllWebzine();
          self.newWebzine.thumbnail = "";
          self.newWebzine.title = "";
          self.newWebzine.desc = "";
          self.newWebzine.createdAt = "";
          self.editWebzineId = undefined;
        })
        .catch((error) => {
          self.$bvToast.toast("수정에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    removeWebzine(collection, el) {
      const self = this;
      if (confirm("정말 삭제할까요?")) {
        this.$db
          .collection(collection)
          .doc(el._id)
          .delete()
          .then(() => {
            alert("삭제가 완료되었습니다.");
            self.loadAllWebzine();
          });
      } else {
        alert("삭제가 취소되었습니다.");
      }
    },

    // 자료
    uploadfiles(el) {
      const file = el.target.files[0];

      this.$storage
        .ref()
        .child("files/" + file.name)
        .put(file)
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            this.newDataRoom.files = url;
            this.$bvToast.toast("업로드를 계속 진행해도 괜찮습니다.", {
              title: `파일을 성공적으로 업로드했습니다.`,
              toaster: "b-toaster-bottom-center",
              variant: "primary",
              appendToast: true,
            });
          });
        })
        .catch((error) => {
          this.$bvToast.toast("수정에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    uploadDataRoom(collection) {
      const self = this;
      this.$db
        .collection(collection)
        .add({
          title: this.newDataRoom.title,
          desc: this.newDataRoom.desc,
          files: this.newDataRoom.files,
          createdAt: new Date().toLocaleDateString(),
        })
        .then(() => {
          self.loadAllDataroom();
          self.newDataRoom.title = "";
          self.newDataRoom.desc = "";
          self.newDataRoom.files = "";

          self.$bvToast.toast("업로드 성공!", {
            title: `파일을 성공적으로 업로드했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
        })
        .catch((error) => {
          self.$bvToast.toast("수정에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    editDataRoom(el) {
      window.scrollTo(0, 0);

      this.editDataRoomId = el._id;
      console.log(this.editDataRoomId);

      this.newDataRoom.title = el.title;
      this.newDataRoom.desc = el.desc;
      this.newDataRoom.files = el.files;
    },
    updateDataRoom(collection) {
      const self = this;

      this.$db
        .collection(collection)
        .doc(this.editDataRoomId)
        .update({
          title: this.newDataRoom.title,
          desc: this.newDataRoom.desc,
          files: this.newDataRoom.files,
        })
        .then(function() {
          self.loadAllDataroom();
          self.$bvToast.toast("수정 완료!", {
            title: `자료를 성공적으로 수정했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
          self.newDataRoom.title = "";
          self.newDataRoom.desc = "";
          self.newDataRoom.files = "";
          self.editDataRoomId = undefined;
        })
        .catch(function(error) {
          self.$bvToast.toast("수정에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    removeDataRoom(collection, el) {
      const self = this;
      if (confirm("정말 삭제할까요?")) {
        this.$db
          .collection(collection)
          .doc(el._id)
          .delete()
          .then(function() {
            self.loadAllDataroom();
            self.$bvToast.toast("삭제를 완료했습니다", {
              title: `자료 삭제를 완료했습니다.`,
              toaster: "b-toaster-bottom-center",
              variant: "primary",
              appendToast: true,
            });
          });
      } else {
        alert("삭제가 취소되었습니다.");
      }
    },

    // Movie
    uploadMovie(collection) {
      const self = this;
      this.$db
        .collection(collection)
        .add({
          src: this.movieLink,
        })
        .then(function() {
          self.loadAllMovies();
          self.movieLink = "";

          self.$bvToast.toast("업로드 성공!", {
            title: `Movie를 성공적으로 업로드했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
        })
        .catch(function(error) {
          console.log(error);
          self.$bvToast.toast("업로드에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    editMovie(el) {
      window.scrollTo(0, 0);

      this.editMovieId = el._id;
      console.log(this.editMovieId);
      this.movieLink = el.src;
    },
    updateMovie(collection) {
      const self = this;

      this.$db
        .collection(collection)
        .doc(this.editDataRoomId)
        .update({
          title: this.newDataRoom.title,
          desc: this.newDataRoom.desc,
          files: this.newDataRoom.files,
        })
        .then(function() {
          self.loadAllDataroom();
          self.$bvToast.toast("수정 완료!", {
            title: `자료를 성공적으로 수정했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
          self.newDataRoom.title = "";
          self.newDataRoom.desc = "";
          self.newDataRoom.files = "";
        })
        .catch(function(error) {
          self.$bvToast.toast("수정에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    removeMovie(collection, el) {
      const self = this;
      if (confirm("정말 삭제할까요?")) {
        this.$db
          .collection(collection)
          .doc(el._id)
          .delete()
          .then(function() {
            self.loadAllMovies();
            self.$bvToast.toast("삭제를 완료했습니다", {
              title: `Movie를 삭제 했습니다.`,
              toaster: "b-toaster-bottom-center",
              variant: "primary",
              appendToast: true,
            });
          });
      } else {
        alert("삭제가 취소되었습니다.");
      }
    },

    // Map
    uploadImage(el) {
      const file = el.target.files[0];

      this.$storage
        .ref()
        .child("mapImages/" + new Date().getTime() + file.name)
        .put(file)
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            this.newMap.imgs.push(url);

            this.$bvToast.toast("업로드를 계속 진행해도 괜찮습니다.", {
              title: `이미지를 올렸습니다. 성공적으로 업로드했습니다.`,
              toaster: "b-toaster-bottom-center",
              variant: "primary",
              appendToast: true,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    uploadMap(collection) {
      const self = this;
      this.$db
        .collection(collection)
        .add({
          name: this.newMap.name,
          position: this.newMap.position,
          staff: this.newMap.staff,
          addr: this.newMap.addr,
          tel: this.newMap.tel,
          website: this.newMap.website,
          desc: this.newMap.desc,
          imgs: this.newMap.imgs,
          color: this.newMap.color,
        })
        .then(function() {
          self.loadAllMap();
          self.newMap.name = "";
          self.newMap.position = "";
          self.newMap.staff = "";
          self.newMap.addr = "";
          self.newMap.tel = "";
          self.newMap.website = "";
          self.newMap.desc = "";
          self.newMap.imgs = "";
          self.newMap.color = "#7a2a90";

          self.$bvToast.toast("업로드 성공!", {
            title: `새 마술소를 성공적으로 추가했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
        })
        .catch(function(error) {
          console.log(error);
          self.$bvToast.toast("업로드에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    editMap(el) {
      window.scrollTo(0, 0);

      this.editMapId = el._id;
      console.log(this.editMapId);

      this.newMap.title = el.title;
      this.newMap.name = el.name;
      this.newMap.position.lat = el.position.lat;
      this.newMap.position.lng = el.position.lng;
      this.newMap.staff = el.staff;
      this.newMap.addr = el.addr;
      this.newMap.website = el.website;
      this.newMap.desc = el.desc;
      this.newMap.imgs = el.imgs;
      this.newMap.color = el.color ? el.color : "#7a2a90";
    },
    updateMap(collection) {
      const self = this;

      this.$db
        .collection(collection)
        .doc(this.editMapId)
        .update({
          name: this.newMap.name,
          position: this.newMap.position,
          staff: this.newMap.staff,
          addr: this.newMap.addr,
          tel: this.newMap.tel,
          website: this.newMap.website,
          desc: this.newMap.desc,
          imgs: this.newMap.imgs,
          color: this.newMap.color ? this.newMap.color : "#7a2a90",
        })
        .then(function() {
          self.loadAllMap();
          self.newMap.name = "";
          self.newMap.position.lat = "";
          self.newMap.position.lng = "";
          self.newMap.staff = "";
          self.newMap.addr = "";
          self.newMap.website = "";
          self.newMap.desc = "";
          self.newMap.imgs = "";
          self.editMapId = undefined;
          self.newMap.color = "#7a2a90";

          self.$bvToast.toast("수정 완료!", {
            title: `지도를 성공적으로 수정했습니다.`,
            toaster: "b-toaster-bottom-center",
            variant: "primary",
            appendToast: true,
          });
        })
        .catch(function(error) {
          self.$bvToast.toast("수정에 실패했습니다", {
            title: error,
            toaster: "b-toaster-bottom-center",
            variant: "error",
            appendToast: true,
          });
        });
    },
    removeMap(collection, el) {
      const self = this;
      if (confirm("정말 삭제할까요?")) {
        this.$db
          .collection(collection)
          .doc(el._id)
          .delete()
          .then(function() {
            self.loadAllMap();
            self.$bvToast.toast("삭제를 완료했습니다", {
              title: `마술소 데이터를 삭제 했습니다.`,
              toaster: "b-toaster-bottom-center",
              variant: "primary",
              appendToast: true,
            });
          });
      } else {
        alert("삭제가 취소되었습니다.");
      }
    },

    // 갤러리
    // 인트로이미지 추가
    uploadIntroImage(el) {
      const file = el.target.files[0];
      this.$storage
        .ref()
        .child("introImages/" + new Date().getTime() + file.name)
        .put(file)
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            // this.introImages.push(url);
            const self = this;
            this.$db
              .collection("introImages")
              .add({
                src: url,
                createdAt: new Date().toJSON(),
              })
              .then(function() {
                self.loadAllIntroImages();

                self.$bvToast.toast("인트로 이미지 추가 성공", {
                  title: `이미지를 올렸습니다. 성공적으로 업로드했습니다.`,
                  toaster: "b-toaster-bottom-center",
                  variant: "primary",
                  appendToast: true,
                });
              })
              .catch(function(error) {
                console.log(error);
                self.$bvToast.toast("업로드에 실패했습니다", {
                  title: error,
                  toaster: "b-toaster-bottom-center",
                  variant: "error",
                  appendToast: true,
                });
              });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeIntroImage(el) {
      const self = this;
      if (confirm("정말 삭제할까요?")) {
        this.$db
          .collection("introImages")
          .doc(el._id)
          .delete()
          .then(() => {
            alert("삭제가 완료되었습니다.");
            self.loadAllIntroImages();
          });
      } else {
        alert("삭제가 취소되었습니다.");
      }
    },
    // 갤러리 이미지 추가
    uploadGalleryImage(el) {
      const file = el.target.files[0];
      this.$storage
        .ref()
        .child("galleryImages/" + new Date().getTime() + file.name)
        .put(file)
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            // this.galleryImages.push(url);
            const self = this;
            this.$db
              .collection("galleryImages")
              .add({
                src: url,
                createdAt: new Date().toJSON(),
              })
              .then(function() {
                self.loadAllGalleryImages();

                self.$bvToast.toast("갤러리 이미지 추가 성공", {
                  title: `이미지를 올렸습니다. 성공적으로 업로드했습니다.`,
                  toaster: "b-toaster-bottom-center",
                  variant: "primary",
                  appendToast: true,
                });
              })
              .catch(function(error) {
                console.log(error);
                self.$bvToast.toast("업로드에 실패했습니다", {
                  title: error,
                  toaster: "b-toaster-bottom-center",
                  variant: "error",
                  appendToast: true,
                });
              });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeGalleryImage(el) {
      const self = this;
      if (confirm("정말 삭제할까요?")) {
        this.$db
          .collection("galleryImages")
          .doc(el._id)
          .delete()
          .then(() => {
            alert("삭제가 완료되었습니다.");
            self.loadAllGalleryImages();
          });
      } else {
        alert("삭제가 취소되었습니다.");
      }
    },
  },

  async mounted() {
    await this.loadAllWebzine();
    await this.loadAllMovies();
    await this.loadAllDataroom();
    await this.loadAllMap();
    await this.loadAllIntroImages();
    await this.loadAllGalleryImages();

    await this.$store.commit("loadingAnime");
  },
};
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";

h2,
h5,
h6 {
  color: #7a2a90;
  font-weight: 700;
}
.new-webzine-thumbnail {
  width: 24rem;
  height: 16rem;
  background-size: cover;
}
.icon-loading {
  opacity: 0;
}
.table_thumbnail {
  width: 88px !important;
  height: auto !important;
}

.editor /deep/ img {
  width: 60% !important;
  height: auto;
}

.new-video-confirm {
  background-color: #eeeeef;
  width: 420px;
  height: 360px;
}
.movie-el {
  height: 360px;
}
.table_image {
  width: 120px !important;
  height: auto !important;
}
</style>
